import { useMatch } from "./useMatch.js";
function useSearch(opts) {
  return useMatch({
    from: opts.from,
    strict: opts.strict,
    structuralSharing: opts.structuralSharing,
    select: (match) => {
      return opts.select ? opts.select(match.search) : match.search;
    }
  });
}
export {
  useSearch
};
//# sourceMappingURL=useSearch.js.map
